import {observer} from "mobx-react";
import {Component} from "preact";
import {OccupancyResponse} from "../model";
import {resources} from "../resources";
import {Button} from "./controls/Button";
import {Dialog, DialogContent, DialogTitle} from "./controls/Dialog";
import {Icon} from "./controls/Icon";
import {Spacer} from "./controls/Spacer";
import style from "./OpenLockerDialog.module.css";

interface Props {
	open: boolean;
	onClose: () => void;
	onOpenAndKeep: () => void;
	onOpenAndRelease: () => void;
	openAndKeepPending: boolean;
	openAndReleasePending: boolean;
	occupancy: OccupancyResponse;
}

export const OpenLockerDialog = observer(
	class OpenLockerDialog extends Component<Props> {
		render() {
			const {
				open,
				onClose,
				onOpenAndKeep,
				onOpenAndRelease,
				openAndKeepPending,
				openAndReleasePending,
				occupancy,
			} = this.props;
			const disabled = openAndKeepPending || openAndReleasePending;
			const askReleaseLocker = occupancy.box.cube.site.askReleaseLocker && occupancy && occupancy.openedTimes
				&& occupancy.openedTimes > 0;
			return (
				<Dialog open={open} onBackdropClick={onClose}>
					<DialogContent>
						<DialogTitle>{resources.strings.OpenLocker}</DialogTitle>

						<div class={style.location}>
							<div className={style.cubeIcon}>
								<Icon>location_on</Icon>
							</div>
							<div className={style.cubeLocation}>
								<div className={style.siteName}>{occupancy.box.cube.site.name}</div>
								<div className={style.cubeName}>{occupancy.box.cube.name}</div>
							</div>
							<div className={style.lockerNumber}>
								{occupancy.box.name}
							</div>
						</div>

						<Button success pending={openAndKeepPending} disabled={disabled} onClick={onOpenAndKeep}>
							{resources.strings.OpenAndKeep}
						</Button>

						{(occupancy.box.cube.site.enableRelease || askReleaseLocker)
							&& (
								<Button
									danger
									pending={openAndReleasePending}
									disabled={disabled}
									onClick={onOpenAndRelease}
								>
									{resources.strings.OpenAndRelease}
								</Button>
							)}

						<Spacer height={"10vh"} />

						<Button onClick={onClose}>
							{resources.strings.Cancel}
						</Button>
					</DialogContent>
				</Dialog>
			);
		}
	},
);
